import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let routes = [];

/**
 * router路由自动化挂载
 * require.context() 函数接收三个参数：
 * 1、要搜索的文件夹目录
 * 2、是否还应该搜索它的子目录
 * 3、以及一个匹配文件的正则表达式
 *
 * 此法用于动态引入文件
 *
 * 返回：一个函数，意思就是说，require.context模块导出（返回）一个（require）函数。
 * 该函数有三个属性：
 * 1、resolve： 是一个函数，它返回请求被解析后得到的模块 id。
 * 2、keys： 也是一个函数，它返回一个数组，由所有可能被上下文模块处理的请求组成。 此处 routerContext.keys() 打印的是 router 目录下所有'.js'结尾的文件集合
 * 3、id： 是上下文模块里面所包含的模块 id. 它可能在你使用 module.hot.accept 的时候被用到
 */
const routerContext = require.context('./', true, /\.js$/);
// console.log(routerContext);
// console.log(routerContext.keys());
routerContext.keys().forEach(route => {
  // 如果是根目录的 index.js 、不处理
  if (route.startsWith('./index')) {
    return
  }
  const routerModule = routerContext(route)
  // console.log(routerModule);

  /**
   * 兼容 import export 和 require module.export 两种规范
   */
  routes = [...routes, ...(routerModule.default || routerModule)]
})

const router = new VueRouter({
  mode: "history",
  base: "/scjgyzt-public/xk/fillFoodProducersWebsites/",
  routes: routes
})

// 进入路由前方法勾子(全局前置守卫)
/*router.beforeEach((to, from , next) => {
  let token = window.localStorage.getItem("token");

  if (to.name !== 'login' && !token) next({ name: 'login' })
  else next()
})*/

// 进入路由后方法勾子(全局前置守卫)
/*router.afterEach((to, from ) => {

})*/

export default router
